// 导入请求数据的 request 模块
import request from '@/utils/request'

// 查询信息
export const selectNation = (currentPage, pageSize) => {
  return request.get('/nation/select', {
    params: {
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}

// 根据学校名称查询信息
export const selectNationName = (name, currentPage, pageSize) => {
  return request.get('/nation/select/name', {
    params: {
      name: name,
      currentPage: currentPage,
      pageSize: pageSize
    }
  })
}
